export const GET_RESULTS_ANNUAL_CHART = "GET_RESULTS_WEEKLY_CHART";
export const GET_RESULTS_MONTHLY_CHART = "GET_RESULTS_MONTHLY_CHART";
export const GET_RESULTS_WEEKLY_CHART = "GET_RESULTS_WEEKLY_CHART";
export const GET_RESULTS_HAPPINESS = "GET_RESULTS_HAPPINESS";
export const GET_STATE_LOADING = "GET_STATE_LOADING";